import ContactUserInfo from './ContactUserInfo.component';

export default ContactUserInfo;
